// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bkRuido{
  margin: 3px auto;
    width: 585px;
   height: 500px;
   transform: rotate(7deg); 
  display: flex;
}
#vhs {display:none}
  
  
   
  
  .image{
   position:absolute;
  height: 438px;
  width: 696px;
  bottom: 33px;
  padding-left: 44px;

  }

  .cable{
    top: 0px;
    position:absolute;
    height: 91px;
    display: block;
    
  }
  .laptop{
   top: 37px;
   position:absolute;
   width: 876px;
   height: 587px;
  }


  
 @media screen and (max-width: 1699px) {
    
  .bkRuido{
    margin: 3px auto;
      width: 585px;
     height: 500px;
     transform: rotate(7deg); 
    display: flex;
    float: right;
    
     
     }
    
    .image{
     position:absolute;
    height: 303px;
    width: 481px;
    top:-18px;
    left: 9px;
    padding-left:0;
    }
  
    .cable{
      top: -123px;
      position:absolute;
      height: 63px;
      display: block;
      
    }
    .laptop{
     top: 0px;
     position:absolute;
     width: 644px;
     height: 403px;
    }

  }

  @media screen and (max-width: 955px) {



    .bkRuido{ 
      margin: 3px auto;
      width: 389px;
      height: 280px;
       transform: rotate(7deg); 
      display: flex;
      float: right;
      
       
       }
      
      .image{
       position:absolute;
      height: 205px;
      width: 326px;
      top: -17px;
      left: 9px;
      padding-left:0;
      }
    
      .cable{
        top: -205px;
        position:absolute;
        height:31px;
        display: block;
        left: 51px;
        
      }
      .laptop{
        top: 7px;
        position: absolute;
        width: 445px;
        height: 275px;
        left: 25px;
      }
  }

  @media screen and (max-width: 655px) {

#vhs{display: block;}

.bkRuido{ transform: rotate(0deg); }
    .cable{display: none; }

      .laptop{
        top: 7px;
        position: absolute;
        width: 295px;
        height: auto;
        left: 25px;
      }
      .image{
        position: absolute;
    height: auto;
    width: 217px;
    top: -4px;
    padding-left: 0;
    left: -25px;
      }
  }

`, "",{"version":3,"sources":["webpack://./src/components/slider/slider.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;IACd,YAAY;GACb,aAAa;GACb,uBAAuB;EACxB,aAAa;AACf;AACA,MAAM,YAAY;;;;;EAKhB;GACC,iBAAiB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;;EAElB;;EAEA;IACE,QAAQ;IACR,iBAAiB;IACjB,YAAY;IACZ,cAAc;;EAEhB;EACA;GACC,SAAS;GACT,iBAAiB;GACjB,YAAY;GACZ,aAAa;EACd;;;;CAID;;EAEC;IACE,gBAAgB;MACd,YAAY;KACb,aAAa;KACb,uBAAuB;IACxB,aAAa;IACb,YAAY;;;KAGX;;IAED;KACC,iBAAiB;IAClB,aAAa;IACb,YAAY;IACZ,SAAS;IACT,SAAS;IACT,cAAc;IACd;;IAEA;MACE,WAAW;MACX,iBAAiB;MACjB,YAAY;MACZ,cAAc;;IAEhB;IACA;KACC,QAAQ;KACR,iBAAiB;KACjB,YAAY;KACZ,aAAa;IACd;;EAEF;;EAEA;;;;IAIE;MACE,gBAAgB;MAChB,YAAY;MACZ,aAAa;OACZ,uBAAuB;MACxB,aAAa;MACb,YAAY;;;OAGX;;MAED;OACC,iBAAiB;MAClB,aAAa;MACb,YAAY;MACZ,UAAU;MACV,SAAS;MACT,cAAc;MACd;;MAEA;QACE,WAAW;QACX,iBAAiB;QACjB,WAAW;QACX,cAAc;QACd,UAAU;;MAEZ;MACA;QACE,QAAQ;QACR,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,UAAU;MACZ;EACJ;;EAEA;;AAEF,KAAK,cAAc,CAAC;;AAEpB,UAAU,uBAAuB,EAAE;IAC/B,OAAO,aAAa,EAAE;;MAEpB;QACE,QAAQ;QACR,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,UAAU;MACZ;MACA;QACE,kBAAkB;IACtB,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,eAAe;IACf,WAAW;MACT;EACJ","sourcesContent":[".bkRuido{\n  margin: 3px auto;\n    width: 585px;\n   height: 500px;\n   transform: rotate(7deg); \n  display: flex;\n}\n#vhs {display:none}\n  \n  \n   \n  \n  .image{\n   position:absolute;\n  height: 438px;\n  width: 696px;\n  bottom: 33px;\n  padding-left: 44px;\n\n  }\n\n  .cable{\n    top: 0px;\n    position:absolute;\n    height: 91px;\n    display: block;\n    \n  }\n  .laptop{\n   top: 37px;\n   position:absolute;\n   width: 876px;\n   height: 587px;\n  }\n\n\n  \n @media screen and (max-width: 1699px) {\n    \n  .bkRuido{\n    margin: 3px auto;\n      width: 585px;\n     height: 500px;\n     transform: rotate(7deg); \n    display: flex;\n    float: right;\n    \n     \n     }\n    \n    .image{\n     position:absolute;\n    height: 303px;\n    width: 481px;\n    top:-18px;\n    left: 9px;\n    padding-left:0;\n    }\n  \n    .cable{\n      top: -123px;\n      position:absolute;\n      height: 63px;\n      display: block;\n      \n    }\n    .laptop{\n     top: 0px;\n     position:absolute;\n     width: 644px;\n     height: 403px;\n    }\n\n  }\n\n  @media screen and (max-width: 955px) {\n\n\n\n    .bkRuido{ \n      margin: 3px auto;\n      width: 389px;\n      height: 280px;\n       transform: rotate(7deg); \n      display: flex;\n      float: right;\n      \n       \n       }\n      \n      .image{\n       position:absolute;\n      height: 205px;\n      width: 326px;\n      top: -17px;\n      left: 9px;\n      padding-left:0;\n      }\n    \n      .cable{\n        top: -205px;\n        position:absolute;\n        height:31px;\n        display: block;\n        left: 51px;\n        \n      }\n      .laptop{\n        top: 7px;\n        position: absolute;\n        width: 445px;\n        height: 275px;\n        left: 25px;\n      }\n  }\n\n  @media screen and (max-width: 655px) {\n\n#vhs{display: block;}\n\n.bkRuido{ transform: rotate(0deg); }\n    .cable{display: none; }\n\n      .laptop{\n        top: 7px;\n        position: absolute;\n        width: 295px;\n        height: auto;\n        left: 25px;\n      }\n      .image{\n        position: absolute;\n    height: auto;\n    width: 217px;\n    top: -4px;\n    padding-left: 0;\n    left: -25px;\n      }\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
